<template>
  <v-row class="pt-5" v-if="items">
    <v-col cols="10" offset="1">
      <v-row v-for="row in content.exercise_success.questions" :key="row.title">
        <v-col cols="12" offset="0">
          <h2 class="text-h5">{{ row.title }}</h2>
        </v-col>

        <v-col cols="6">
          <results-card
            v-model="results[row.short.model]"
            :limit="20"
            :name="row.short.name"
            num=""
            :title="row.short.title"
            description=""
            color="amber"
            bgColor="#494949"
            svg="wing-left-new@2x.png"
            :reverse="false"
          >
          </results-card>
        </v-col>
        <v-col cols="6">
          <results-card
            v-model="results[row.long.model]"
            :limit="20"
            :name="row.long.name"
            num=""
            :title="row.long.title"
            description=""
            color="amber"
            bgColor="#494949"
            svg="wing-right-new@2x.png"
            :reverse="true"
          >
          </results-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import ResultsCard from "@/components/results/success-pillars/ResultsCard";
import { mapState } from "vuex";

export default {
  name: "ResultsTodatTomorrowSummary",
  components: {
    ResultsCard,
  },
  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },

  data() {
    return {
      content: null,
      items: null,
      admins: null,
      results: {
        q1: [],
        q2: [],
        q3: [],
        q4: [],
        q5: [],
        q6: [],
        q7: [],
        q8: [],
        q9: [],
        q10: [],
        q11: [],
        q12: [],
        q13: [],
        q14: [],
        q15: [],
        q16: [],
        q17: [],
        q18: [],
        q19: [],
        q20: [],
      },
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  mounted() {
    this.getExercise();
  },
  methods: {
    getExercise() {
      console.log("getting exercise");
      this.doc = null;
      let ref = fb.successPillarsExCollection.where("pid", "==", this.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.forEach((doc) => {
            let post = doc.data();
            this.getResults(post.doc.matrix);
          });
          if (items) {
            this.items = items;
          }
        })
        .catch(function() {});
    },
    getResults(matrix) {
      Object.entries(matrix).forEach(([a, b]) => {
        if (b && b.length) {
          b.forEach((y) => {
            this.results[a].push(y);
          });
        }
      });
    },
  },
};
</script>
